// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// CRAWLER PERIODIC SETTINGS SCHEMA
/////////////////////////////////////////

export const CrawlerPeriodicSettingsSchema = z.object({
  enabled: z.boolean(),
  windowEnabled: z.boolean(),
  dayOfWeek: z.number().int().nullable(),
  startHour: z.number().int().nullable(),
  timezone: z.string().nullable(),
})

export type CrawlerPeriodicSettings = z.infer<typeof CrawlerPeriodicSettingsSchema>

export default CrawlerPeriodicSettingsSchema;
